import React, { ReactNode } from 'react';
import { Wrapper } from './Wrapper';

export const Header = ({ children }: { children: ReactNode }) => {
  return <Wrapper data-testid="header">{children}</Wrapper>;
};

export * from './variables';

export { FlyOutToggle } from './FlyOutToggle';
